var _defs, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcoNotificacao(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 18.02,
    height: 20,
    viewBox: "0 0 18.02 20",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".a{fill:#fff;}"))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M9,20a2.99,2.99,0,0,1-3-3H1a1,1,0,0,1-.948-1.316L1,12.838V10A9.952,9.952,0,0,1,2.692,4.2,7.4,7.4,0,0,1,7.164,1.206a2,2,0,0,1,3.672,0A7.4,7.4,0,0,1,15.308,4.2,9.952,9.952,0,0,1,17,10v2.838l.889,2.668A1,1,0,0,1,17.02,17H12a2.99,2.99,0,0,1-3,3ZM9,3C5.355,3,3,5.747,3,10v3a1.052,1.052,0,0,1-.05.317L2.388,15H15.612l-.56-1.684A1,1,0,0,1,15,13V10C15,5.747,12.645,3,9,3Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcoNotificacao);
export default __webpack_public_path__ + "static/media/ico-notificacao.48189fece4a48faac7cc53e0344c2da3.svg";
export { ForwardRef as ReactComponent };